import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { IdentityModel } from "../models/identity.model";
import { environment } from "src/environments/environment";
import { map } from 'rxjs/operators';
import { ConsolidatedRequest } from '../models/consolidated.model';
import { CiCdConfigService } from "src/cicd/ci-cd-config.service";

@Injectable({
  providedIn: "root"
})
export class ReportesService {
  private urlApi: string;
  public identity = new IdentityModel();
  public token: any;
  public userData = new IdentityModel();
  public headers: any;

  constructor(public http: HttpClient,
    private readonly ciCd: CiCdConfigService
  ) {
    // this.urlApi = environment.urlApi; // PREJENKINS
    this.ciCdInit();
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));

    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
  }

  ciCdInit() {
    this.ciCd.loadConfigurations().subscribe(({ apis }: any) => {
      const { urlApi } = apis;
      this.urlApi = urlApi;
    });
  }

  getquery(query: string, affiliate: any) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/x-www-form-urlencoded");
    headers = headers.set("token", localStorage.getItem("tokenCVE"));
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    affiliate.tipo_documento = this.userData.v_tipo_documento;
    affiliate.documento = this.userData.v_documento;

    const options = { params: affiliate, headers };
    return this.http.get(`${this.urlApi}/${query}`, options);
  }

  getDebtReport(affiliate: object) {
    return this.getquery("pr_reporte_cartera_afiliado", affiliate);
  }

  getDebtsReport(affiliate: object) {
    return this.getquery("pr_reporte_deudores_afiliado", affiliate);
  }

  getConsolidate(afiliado: ConsolidatedRequest) {
    return this.getquery('pr_consulta_cartera_afiliado_conso', afiliado).pipe(
      map((resp)=> {
        return resp['CONSULTA_CARTERA_AFILIADO_CONSO'] || [];
      })
    );
  }

  getReportWallet(contrac: string) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/x-www-form-urlencoded");
    headers = headers.set("token", localStorage.getItem("tokenCVE"));
    const  url = `${this.urlApi}/pr_reporte_cartera_gestion`;
    const params = {
      contrato: contrac
    }
    const options = {params, headers};
    return this.http.get(url, options).pipe(
      map((resp)=> {
        return resp['REPORTE_DEUDOR'] || [];
      })
    );
  }
}
